import { DeesElement, property, html, customElement } from '@designestate/dees-element';
import { TemplateResult } from 'lit-html';

import '@losslessone_private/lele-catalog';

declare global {
  interface HTMLElementTagNameMap {
    'pc-footer': PcFooter;
  }
}

@customElement('pc-footer')
export class PcFooter extends DeesElement {
  @property()
  public footerText = `Lossless GmbH - 2018`;

  constructor() {
    super();
  }

  public render(): TemplateResult {
    
    return html`
      <style>
        :host {
          display: block;
          height:100px;
        }
        :host([hidden]) {
          display: none;
        }

       
        a {
          color: #fff;
          text-decoration: none;
        }
      </style>
      <div class="footerMain">${this.footerText} - <a href="https://lossless.gmbh">Legal Info</a> | <a href="https://lossless.gmbh">Privacy Policy</a></div>
    `;
  }

}
